<template>
  <v-card class="mx-3 my-3">
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="listadoSucursales.data"
        :loading="listadoSucursales.loading"
        :items-per-page="10"
        :footer-props="{ itemsPerPageOptions: [10, 50, 100, 200] }"
        no-data-text="No se encontraron sucursales"
        item-key="sucursal_id"
      >
        <template v-slot:item.sucursal_id="{ item }">
          {{ mostrarCodigo(item) }}
        </template>

        <template v-slot:item.descripcion_sucursal="{ item }">
          {{ mostrarNombre(item) }}
        </template>

        <template v-slot:item.opciones="{ item }">
          <div class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  @click="emitirEditar(item)"
                >
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="red"
                  v-bind="attrs"
                  v-on="on"
                  @click="manejarEliminar(item)"
                >
                  delete_forever
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SucursalesTable',
  props: {
    listadoSucursales: {
      type: Object,
      default: () => ({ data: [], loading: false }),
    },
    nit: {
      type: String,
      required: true,
    },
    estaEditando: {
      type: Boolean,
    },
  },

  emits: ['editar-sucursal', 'eliminar-sucursal'],

  data() {
    return {
      headers: [
        { text: 'Código', value: 'sucursal_id', width: 120 },
        { text: 'Nombre', value: 'descripcion_sucursal', width: 'auto' },
        {
          text: 'Opciones',
          value: 'opciones',
          sortable: false,
          align: 'center',
          width: 120,
        },
      ],
    };
  },

  methods: {
    mostrarCodigo(item) {
      return item.sucursal_id || item.IdSucursal || '';
    },

    mostrarNombre(item) {
      return item.descripcion_sucursal || item.DescripcionSucursal || '';
    },

    emitirEditar(item) {
      const payload = {
        sucursal_id: this.mostrarCodigo(item),
        descripcion_sucursal: this.mostrarNombre(item),
      };
      this.$emit('editar-sucursal', payload);
    },

    async manejarEliminar(item) {
      const idSucursal = this.mostrarCodigo(item);
      const nombreSucursal = this.mostrarNombre(item);
      if (!this.nit && this.estaEditando) {
        return;
      }
        this.$emit('eliminar-sucursal', idSucursal, nombreSucursal);
    },
  },
};
</script>

<style scoped></style>
